export default __webpack_public_path__ + "static/media/icon-plus-red.bb2f6fab.svg";